import React, { useEffect, useState } from 'react'
import { calculator } from './calculator.module.scss'

const Calculator = ({ onUpdate }) => {
  const [needWidth, setWidth] = useState(1)
  const [needLength, setLength] = useState(1)
  const [needSqft, setSqft] = useState(1)

  const changeWidth = (e) => {
    setWidth(e.target.value)
    handleCalculatorUpdate(e.target.value, needLength)
  }

  const changeLength = (e) => {
    setLength(e.target.value)
    handleCalculatorUpdate(needWidth, e.target.value)
  }

  const handleCalculatorUpdate = (needWidth, needLength) => {
    const timer = setTimeout(() => {
      setSqft(needWidth * needLength)
      onUpdate({
        total: needWidth * needLength,
        width: +needWidth,
        length: +needLength,
      })
    }, 500)

    return () => clearTimeout(timer)
  }

  return (
    <React.Fragment>
      <div className={calculator}>
        <div className='d-flex'>
          <div className='d-block'>
            <label> Width(Ft) </label>
            <input
              min='0'
              type='number'
              id='width'
              name='width'
              value={needWidth}
              onChange={(e) => changeWidth(e)}
            />
          </div>
          <span> X </span>
          <div className='d-block'>
            <label> Length(Ft) </label>
            <input
              min='0'
              type='number'
              id='length'
              name='length'
              value={needLength}
              onChange={(e) => changeLength(e)}
            />
          </div>
          <span> = </span>
          <div className='d-block'>
            <label> Square Ft </label>
            <input
              type='number'
              id='squarefeet'
              name='squarefeet'
              value={needSqft}
              onChange={(e) => setSqft(e.target.value)}
              disabled
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Calculator
